import type { ReactNode } from 'react';
import React from 'react';
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';

import { theme } from '@garnish/constants';

// ─────────────────────────────────────────────────────────────────────────────

export const CarouselFadeStage = (props: CarouselFadeStageProps) => {
  const { children, activeSlideIndex } = props;

  const slides = React.Children.toArray(children);
  const activeSlide = slides[activeSlideIndex];

  if (!activeSlide) return null;

  return (
    <Animated.View key={activeSlideIndex} entering={FADE_ENTERING} exiting={FADE_EXITING}>
      {activeSlide}
    </Animated.View>
  );
};

// ─── Constants ───────────────────────────────────────────────────────────────

const FADE_ENTERING = FadeIn.duration(theme.transitions.base);
const FADE_EXITING = FadeOut.duration(theme.transitions.base * 2);

// ─── Types ───────────────────────────────────────────────────────────────────

type CarouselFadeStageProps = Readonly<{
  children: ReactNode;
  activeSlideIndex: number;
}>;
